import React from 'react';
import { Card, Stack, Typography, Badge, Chip, Box } from '@mui/joy';
import CheckIcon from '@mui/icons-material/Check';
import ApplicantThumbnail from '../../components/ApplicantThumbnail';

interface MeetingCardProps {
  meeting: {
    id: string;
    scheduledAt: string;
    location: string;
    duration: number;
    applicants: Array<{
      id: string;
      confirmed: boolean;
    }>;
  };
  onClick: () => void;
}

const MeetingCard: React.FC<MeetingCardProps> = ({ meeting, onClick }) => {
  const startDate = new Date(meeting.scheduledAt);
  const endDate = new Date(startDate.getTime() + meeting.duration); // Convert minutes to milliseconds
  
  const startTime = startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const endTime = endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return (
    <Card 
      sx={{ p: 3, borderRadius: 3, boxShadow: 'sm', cursor: 'pointer' }}
      onClick={onClick}
    >
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} alignItems="center" justifyContent="space-between">
        <Box>
          <Typography level="body-md" sx={{ fontWeight: 600 }}>
            {startDate.toLocaleDateString()} &bull; {startTime} - {endTime}
          </Typography>
          <Typography level="body-sm" sx={{ color: '#7B7F85', mt: 0.5 }}>
            {meeting.location}
          </Typography>
        </Box>
        <Stack direction="row" spacing={2} alignItems="center">
          {meeting.applicants.slice(0, meeting.applicants.length > 5 ? 4 : 5).map((applicant: any) => (
            <Badge
              key={applicant.id}
              badgeContent={applicant.confirmed ? <CheckIcon sx={{ fontSize: 16, color: 'success.500' }} /> : null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              sx={{ mr: 1, width: 40, height: 40 }}
            >
              <Box sx={{ width: 40, height: 40 }}>
                <ApplicantThumbnail applicant={applicant} />
              </Box>
            </Badge>
          ))}
          {meeting.applicants.length > 5 && (
            <Box
              sx={{
                width: 40,
                height: 40,
                backgroundColor: '#E5E7EB',
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 1
              }}
            >
              <Typography level="body-sm" sx={{ fontWeight: 600, color: '#6B7280' }}>
                +{meeting.applicants.length - 4}
              </Typography>
            </Box>
          )}
        </Stack>
      </Stack>
    </Card>
  );
};

export default MeetingCard; 